export type Breakpoint = (typeof breakpoints)[number] | undefined

// This needs to be synced with the variable names given to the breakpoints in scss
// See `stylesheets/settings/breakpoints.scss`
const breakpoints = [
  'breakpoint--480px',
  'breakpoint--768px',
  'breakpoint--960px',
  'breakpoint--1024px',
  'breakpoint--1280px',
  'breakpoint--1440px',
  'breakpoint--1920px',
] as const

export const getBreakpoint = (): Breakpoint => {
  const cssBreakpoint = window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/\"/g, '')
  return breakpoints.find((breakpoint) => breakpoint === cssBreakpoint)
}
